import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class AiAnalysisFeedbacksService {
  createFeedback({ analysableType, analysableId, analysisType, comment }) {
    return securedAxiosInstance.post(
      "/claims/ai_analysis_feedbacks",
      toSnakeCase({ analysableType, analysableId, analysisType, comment }),
    );
  }
}

export default new AiAnalysisFeedbacksService();
